// Position of the page within the request that produced it. Split tasks
// label every page they yield with batch * PAGE_ORDER_STRIDE + position, so
// labels are globally unique across the documents of one request and
// consumers can restore order no matter how concurrent streams interleave.
export type PageOrder = { page_order: number }

export const PAGE_ORDER_STRIDE = 1_000_000
